import { render, staticRenderFns } from "./tac.vue?vue&type=template&id=125dfba2&scoped=true"
import script from "./tac.vue?vue&type=script&lang=js"
export * from "./tac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125dfba2",
  null
  
)

export default component.exports